import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { ExamLayoutComponent } from '../../layout/exam-layout/exam-layout.component';
import { ExamHeaderComponent } from '../../layout/exam-layout/header/exam-header.component';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatMiniFabButton, MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { ExamFooterComponent } from '../../layout/exam-layout/footer/exam-footer.component';

@Component({
    selector: 'app-troubleshoot-page',
    templateUrl: './troubleshoot-page.component.html',
    styleUrls: ['./troubleshoot-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ExamLayoutComponent, ExamHeaderComponent, MatCard, MatCardContent, MatMiniFabButton, RouterLink, MatIcon, MatButton, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, ExamFooterComponent]
})
export class TroubleshootPageComponent implements OnInit {
  @ViewChild(MatAccordion) accordion!: MatAccordion;

  constructor() { }

  ngOnInit(): void {
  }

}
